import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconNewTagOrange = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 14,
		height: 14,
		rx: 4,
		ry: 4,
		fill: "#F97316"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.25 4.8252V9.17477H8.10152L6.15851 6.82576H6.12239V9.17477H4.75V4.8252H5.92014L7.83427 7.16219H7.87761V4.8252H9.25Z",
		fill: "white"
	})]
});
export default SvgIconNewTagOrange;
